module.exports = __webpack_public_path__ + "static/media/thermostat.702eb3d0.jpg";